import styled from '@emotion/styled';

export const Wrapper = styled.div<{ noPadding?: boolean }>`
  display: flex;
  flex-direction: center;
  justify-content: center;
  padding: {{ !noPadding }} ? 100px 0 : 0;
`;
